import { useEffect, useState } from 'react';
import { Button, Col, Table, notification, Form, DatePicker } from 'antd';

import { Row } from 'antd';
import { Link } from 'react-router-dom';
import API from 'src/services/api-service';
import dayjs, { Dayjs } from 'dayjs';

export default function InventoryWorkersPage() {
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const getInventoryWorkers = async (filters?: any) => {
    try {
      setLoading(true);
      const response = await API.get('/api/statistics/inventory-workers', {
        params: filters,
      });
      if (response.status !== 200) {
        throw new Error('Lỗi khi lấy dữ liệu');
      }
      setData(response.data);
    } catch (error) {
      notification.error({
        message: 'Lỗi khi lấy dữ liệu',
      });
    } finally {
      setLoading(false);
    }
  };

  const onFilter = async () => {
    const data = form.getFieldsValue();
    const filters = {
      from: (data.date[0] as Dayjs).format('YYYY-MM-DD'),
      to: (data.date[1] as Dayjs).format('YYYY-MM-DD'),
    };
    await getInventoryWorkers(filters);
  };

  useEffect(() => {
    const data = form.getFieldsValue();
    const filters = {
      from: (data.date[0] as Dayjs).format('YYYY-MM-DD'),
      to: (data.date[1] as Dayjs).format('YYYY-MM-DD'),
    };
    getInventoryWorkers(filters);
  }, []);

  const columns = [
    {
      title: 'Tên thợ',
      dataIndex: 'workerName',
    },
    // {
    //   title: 'Sản phẩm',
    //   key: 'products',
    //   render: (record: any) => {
    //     console.log(record);
    //     return record.products.map((p: any) => (
    //       <Row key={p.id}>
    //         <Col span={18}>{p.productName}</Col>
    //         <Col span={4}>{p.holding}</Col>
    //       </Row>
    //     ));
    //   },
    // },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'productName',
    },
    {
      title: 'Số lượng xuất',
      dataIndex: 'exported',
    },
    {
      title: 'Số lượng lắp',
      dataIndex: 'installed',
    },
    {
      title: 'Số lượng còn giữ',
      dataIndex: 'holding',
    },
  ];
  return (
    <div className="md:p-8 sm:p-4 sm:pt-12">
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        initialValues={{ date: [dayjs('2025-01-01'), dayjs()] }}
      >
        <Row gutter={[16, 0]} className="pb-6">
          <Col span={12}>
            <Form.Item name="date" label="Ngày kiểm kê">
              <DatePicker.RangePicker
                format={'DD-MM-YYYY'}
                className="w-full"
                placeholder={['Ngày kiểm kê từ', 'đến']}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item noStyle className="mb-0">
              <Button type="dashed" onClick={onFilter}>
                Lọc
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Table columns={columns} dataSource={data} loading={loading} />
    </div>
  );
}
